import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../utils';

export const setBrowseSettingsWidgetTheatreView = createAction(
  `${reduxKey}.SET_BROWSESETTINGS_WIDGET_THEATRE_VIEW`,
  (theatreView: 'zoomed_out' | 'zoomed_in') => ({ theatreView })
);

export const setBrowseSettingsWidgetInvisibleBrowsing = createAction(
  `${reduxKey}.SET_BROWSESETTINGS_WIDGET_INVISIBLE_BROWSING`,
  (invisibleBrowsing: boolean) => ({ invisibleBrowsing })
);

export const setBrowseSettingsWidgetBrowseLimit = createAction(
  `${reduxKey}.SET_BROWSESETTINGS_WIDGET_BROWSE_LIMIT`,
  (browseLimit: number) => ({ browseLimit })
);

export const setBrowseSettingsWidgetBrowsePagingMode = createAction(
  `${reduxKey}.SET_BROWSESETTINGS_WIDGET_BROWSE_PAGING_MODE`,
  (browsePagingMode: 'infinite' | 'paged') => ({ browsePagingMode })
);

export const {
  submit: saveBrowseSettings,
  success: saveBrowseSettingsSuccess,
  failure: saveBrowseSettingsFailure,
} = createNetworkRequestActionSet(reduxKey, 'SAVE_BROWSE_SETTINGS');
